module.exports = __webpack_public_path__ + "static/media/ch.efb7dd83.svg";